import { Link } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { Spacer3 } from 'components-ui'
import { AddressLocation, Phone, Website } from '../address'

export const Footer = () => {
  return (
    <Box sx={{ '& a': { textDecoration: 'none', color: 'inherit' } }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        paddingLeft={{ xs: 3, md: 'none' }}
        justifyContent={{ xs: 'left', md: 'center' }}
      >
        <Website />
        <AddressLocation />
        <Phone />
      </Stack>

      <Spacer3 />

      <Stack direction="row" spacing={2} paddingLeft={{ xs: 3, md: 'none' }} justifyContent="center">
        <Typography variant="body2">Powered by Goose</Typography>
        <Typography variant="body2">|</Typography>
        <Link href="https://www.goose.pet/terms-conditions" target="_blank">
          <Typography variant="body2">Terms and Conditions</Typography>
        </Link>
        <Typography variant="body2">|</Typography>
        <Link href="https://www.goose.pet/privacy-policy" target="_blank">
          <Typography variant="body2">Privacy Policy</Typography>
        </Link>
      </Stack>
    </Box>
  )
}
